Pixlee.module('WidgetsApp.Photowall', function(Photowall, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    Photowall.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;
            this.photoscollection = App.request('get:photos:widget:photowall');
            this.collectionView = this.getPhotoCollectionView({
                collection: this.photoscollection,
                global: Pixlee.request('get:display:options').toJSON(),
                type: this.options.type
            });
            var photoSize = Pixlee.request('get:display:options').toJSON().photoSize;
            var cls;
            if (photoSize == 'large_photo') {
                cls = 'photowall_widget_large';
            } else if (photoSize == 'medium_photo') {
                cls = 'photowall_widget_medium';
            } else if (photoSize == 'small_photo') {
                cls = 'photowall_widget_small';
            }
            if (this.options.type === 'horizontal') {
                cls = 'photowall_widget_medium';
            }
            $(this.region.el).addClass(cls);
            var onCollectionrRenderDebounce = _.debounce(this.onRender, 500);
            if (this.options.type === 'photowall') {
                this.collectionView.on({
                    'child:show:lighbox': _this.handlePhotoClick,
                    'render': _this.collectionRendered,
                    'child:share:pinterest': _this.handlePinterestShare,
                    'child:share:twitter': _this.handleTwitterShare,
                    'child:share:facebook': _this.handleFacebookShare,
                    'child:share:tumblr': _this.handleTumblrShare,
                    'child:vote:clicked': _this.voteClicked,
                    'add:child': onCollectionrRenderDebounce
                });
            } else if (this.options.type === 'horizontal') {
                this.collectionView.on({
                    'child:show:lighbox': _this.handlePhotoClick,
                    'child:share:pinterest': _this.handlePinterestShare,
                    'child:share:twitter': _this.handleTwitterShare,
                    'child:share:facebook': _this.handleFacebookShare,
                    'child:share:tumblr': _this.handleTumblrShare,
                    'child:vote:clicked': _this.voteClicked,
                    'render': _this.collectionRendered,
                    'add:child': onCollectionrRenderDebounce,
                    'nav:arrow:left': _this.navLeft,
                    'nav:arrow:right': _this.navRight
                });
            }
            if (this.options.type === 'horizontal') {
                $(this.region.el).addClass('horizontal-widget-active');
            }
            this.photowallLayout = App.request('photowall:wrapper', this.collectionView);
            this.show(this.photowallLayout);
        },
        getPhotoCollectionView: function(options) {
            if (this.options.type === 'photowall') {
                if (gon.isMobileDevice) {
                    return new Photowall.PhotoWallMobileCollectionView(options);
                } else {
                    return new Photowall.PhotoWallCollectionView(options);
                }
            } else if (this.options.type === 'horizontal') {
                if (gon.isMobileDevice) {
                    return new Photowall.HorizontalMobileCollectionView(options);
                } else {
                    return new Photowall.HorizontalCollectionView(options);
                }
            }

        },
        handlePinterestShare: function(view, model) {
            App.commands.execute('open:share:pinterest', model);
        },
        handleTwitterShare: function(view, model) {
            App.commands.execute('open:share:twitter', model);
        },
        handleFacebookShare: function(view, model) {
            App.commands.execute('open:share:facebook', model);
        },
        handleTumblrShare: function(view, model) {
            App.commands.execute('open:share:tumblr', model);
        },
        voteClicked: function(view, model) {
            App.commands.execute('exec:vote:clicked', view, model);
        },
        handlePhotoClick: function(child, args) {
            App.vent.trigger('show:photowall:item', args.model, args.model.collection);
        },
        onRender: function() {
            if (this.options.type === 'horizontal' && !this.keyDownInitialized) {
                var _this = this;
                this.keyDownInitialized = true;
                $(window).on('keydown', function(e) {
                    if ($('#photos_container').hasClass('lightbox-is-active')) return false;
                    if (e.keyCode === 39) {
                        _this.navRight();
                    } else if (e.keyCode === 37) {
                        _this.navLeft();
                    }
                });
            }
            App.commands.execute('lightbox:init', this.collection);
        },
        navLeft: function() {
            this.navLeft();
        },
        navRight: function() {
            this.navRight();
        }
    });

});